import api from 'api'

export const removeField = async (stepId, id) => {
  const { data } = await api.delete(`/step/${stepId}/field/${id}`)

  return data
}
